import CustomerDatasourceLicence from './CustomerDatasourceLicence';

export interface RawCustomerDatasourceLicence {
	id: string;
	datasource: string;
	type: string;
}

export default function mapCustomerDatasourceLicence(license: RawCustomerDatasourceLicence): CustomerDatasourceLicence {
	return new CustomerDatasourceLicence(license.id, license.datasource, license.type);
}
